module.exports = __webpack_public_path__ + "static/media/textodisenio.52a6d24f.png";